import {Component} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent {

    constructor(
        private metas: Meta,
        private titlePage: Title
    ) {
        const TITLE = 'Teste gratuitamente nossa assinatura digital | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Obtenha uma assinatura digital gratuita e comece a experimentar o FAD®. Baixe o aplicativo para dispositivos móveis e assine de qualquer lugar do mundo.';
        const URL = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-gratis';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/prueba.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'firma digital gratis, crear firma digital gratis'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });

        window.scrollTo(0, 0);

    }

}
